import { createContext } from 'react';
/**
 * Create the React Context
 */
export const DndContext = createContext({
  dragDropManager: undefined
});